import React, {Fragment} from 'react';
import PageBodyWrapper from "root/PageBodyWrapper";
import SchoolsContainer from "root/SchoolsContainer";
import { Tab, Tabs } from "react-bootstrap";
import TeachersContainer from "root/TeachersContainer";
import { TeacherFilter} from "root/DataFunctions/Constants";
const AdminSchoolPageBody = () =>
{
    return (
        <Fragment>
             <PageBodyWrapper title='Administration'>
                         <Tabs defaultActiveKey="schools" id="schools-tab" className="mb-3" mountOnEnter={ true }>
                             <Tab eventKey="schools" title="Schools">
                                 <SchoolsContainer />
                             </Tab>
                             <Tab eventKey="admins" title="Administrators">
                                 <TeachersContainer provider_id={ null } filter={TeacherFilter.ADMIN} suppressAdd={false}/>
                             </Tab>
                             <Tab eventKey="teachers" title="Safeguarding Leads">
                                 <TeachersContainer provider_id={ null } filter={TeacherFilter.PRIMARY_DSL} suppressAdd={true}/>
                             </Tab>
                         </Tabs>
            </PageBodyWrapper>
        </Fragment>
    )
}

export default AdminSchoolPageBody;
